import { createSlice } from '@reduxjs/toolkit';
import { EngagementMeetingsState } from './engagement-conferences.state';
import { FetchEngagementConferences } from './thunks/fetch-engagement-conferences.thunk';
import { AddEngagementConference } from './thunks/add-engagement-conferences.thunk';

const initialState: EngagementMeetingsState = {
    engagementMeetings: [],
    isLoading: false,
    status: 'succeeded',
    error: '',
};

const engagementConferencesSlice = createSlice({
    name: 'engagementMeetings',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(FetchEngagementConferences.pending, (state) =>
                setPendingState(state)
            )
            .addCase(FetchEngagementConferences.rejected, (state, action) =>
                setRejectedState(
                    state,
                    action.error.message ||
                        'Failed to fetch engagement meetings'
                )
            )
            .addCase(FetchEngagementConferences.fulfilled, (state, action) => {
                state.engagementMeetings = action.payload;
                setSucceededState(state);
            })

            .addCase(AddEngagementConference.pending, (state) => {
                state.error = '';
            })
            .addCase(AddEngagementConference.rejected, (state, action) => {
                state.isLoading = false;
                state.status = 'failed';
                state.error =
                    action.error.message || 'Failed to add engagement meeting';
            })
            .addCase(AddEngagementConference.fulfilled, (state, action) => {
                state.isLoading = false;
                state.status = 'succeeded';
                state.error = '';
            });
    },
});

const setRejectedState = (
    state: EngagementMeetingsState,
    errorMessage: string
) => {
    state.isLoading = false;
    state.status = 'failed';
    state.error = errorMessage;
};

const setPendingState = (state: EngagementMeetingsState) => {
    state.isLoading = true;
    state.status = 'loading';
    state.error = '';
};

const setSucceededState = (state: EngagementMeetingsState) => {
    state.isLoading = false;
    state.status = 'succeeded';
    state.error = '';
};

export const {} = engagementConferencesSlice.actions;
export default engagementConferencesSlice.reducer;
